<template>
  <v-data-table :headers="headers"
                :items="debt.bills"
                item-key="nr"
                class="mt-4"
                hide-default-footer
                :mobile-breakpoint="0"
                show-expand
                :class="{ 'elevation-1': $vuetify.breakpoint.smAndDown }"
                @click:row="expand"
                :items-per-page="-1"
                :expanded.sync="expanded"
                data-matomo-mask>
    <template #item.capital="{ item }">
      {{ item.capital | currency }}
    </template>
    <template #item.dueDate="{ item }">
      {{ item.dueDate | formatDate }}
    </template>
    <template #item.interest="{ item }">
      {{ item.interest | currency }}
    </template>
    <template #item.total="{ item }">
      {{ item.total | currency }}
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <v-row>
          <template v-if="$vuetify.breakpoint.smAndDown">
            <v-col cols=12>
              <div><span class="font-weight-bold">{{ $t('billNr') }}:</span> <span>{{ item.referenceNr }}</span></div>
            </v-col>
            <v-col cols=12>
              <div><span class="font-weight-bold">{{ $t('dueDate') }}:</span> <span>{{ item.dueDate | formatDate }}</span></div>
            </v-col>
          </template>
          <v-col cols=12>
            <div><span class="font-weight-bold">{{ $t('sum') }}:</span> <span>{{ item.capital | currency }}</span></div>
          </v-col>
          <v-col cols=12 v-if="item.interestRate > 0">
            <div><span class="font-weight-bold">{{ $t('interestPercent') }}:</span> <span>{{ item.interestRate }}</span></div>
          </v-col>
          <v-col cols=12>
            <div><span class="font-weight-bold">{{ $t('interestAmount') }}:</span> <span>{{ item.interest | currency }}</span></div>
          </v-col>
        </v-row>
      </td>
    </template>
  </v-data-table>
</template>

<script>
  export default {
    data: function () {
      return {
        expanded: []
      }
    },
    props: ['debt'],
    methods: {
      expand (value) {
        const index = this.expanded.indexOf(value)
        if (index === -1) {
          this.expanded.push(value)
        } else {
          this.expanded.splice(index, 1)
        }
      }
    },
    computed: {
      headers () {
        let desktopHeaders = [
          { text: '', value: 'data-table-expand' },
          { text: this.$t('debtDescription'), value: 'description' },
          { text: this.$t('billNr'), value: 'referenceNr' },
          { text: this.$t('dueDate'), value: 'dueDate' },
          { text: this.$t('total'), value: 'total' }
        ]

        let mobileHeaders = [
          { text: '', value: 'data-table-expand' },
          { text: this.$t('debtDescription'), value: 'description' },
          { text: this.$t('total'), value: 'total' },
        ]

        return this.$vuetify.breakpoint.smAndDown ? mobileHeaders : desktopHeaders
      },
    }
  }
</script>

<i18n>
  {
  "fi": {
  "debtDescription": "Velkakuvaus",
  "interestPercent": "Viiv. korko %",
  "interestAmount": "Viiv. korko €"
  },
  "se": {
  "debtDescription": "Skuldbeskrivning",
  "interestPercent": "Förs. ränta %",
  "interestAmount": "Förs. ränta €"
  },
  "en": {
  "debtDescription": "Debt description",
  "interestPercent": "Pen. int. %",
  "interestAmount": "Pen. int. €"
  }
  }
</i18n>
